var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"currentTree",attrs:{"data":_vm.data,"show-checkbox":"","node-key":"id","props":_vm.props,"node-key":_vm.props.value,"default-expand-all":""},on:{"check-change":_vm.handleCheckChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-206c1d37","hasScoped":true,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/trainingManagement/component/chapterLayout.vue
// module id = 1240
// module chunks = 72